import { useTranslations } from 'next-intl';
import { NoLeaderboardData } from '../leaderboard/no-leaderboard';
import styles from './solo-event-leaderboard-empty.module.css';

export const SoloEventLeaderboardEmpty = () => {
  const t = useTranslations();
  return (
    <div className={styles.noDataWrapper}>
      <div className={styles.header}>
        <p>Individual Leaderboard</p>
        <p className={styles.helpText}>(By number of points)</p>
      </div>
      <div className={styles.noData}>
        <NoLeaderboardData
          title={t('empty_leaderboard_title')}
          description={null}
        />
      </div>
    </div>
  );
};
